import { Middleware } from '@reduxjs/toolkit';
import { setStatus } from '../features/app/appSlice';
import i18next from 'i18next';

export const errorMiddleware: Middleware = () => next => action => {
  // Verificar si la acción es rechazada (error)
  if (
    typeof action === 'object' &&
    action !== null &&
    'type' in action &&
    typeof action.type === 'string' &&
    action.type.endsWith('/rejected')
  ) {
    const error = 'payload' in action ? action.payload : 'error' in action ? action.error : null;

    // Verificar si es un error de seguridad (401 o 403)
    if (
      error &&
      typeof error === 'object' &&
      'status' in error &&
      (error.status === 401 || error.status === 403)
    ) {
      // Determinar el tipo de error y el mensaje
      const isAuthError = error.status === 401;
      const errorType = isAuthError ? 'error' : 'warning';
      const errorMessage = isAuthError
        ? i18next.t('status.authError')
        : i18next.t('status.forbiddenError');

      // Obtener los detalles del error
      let errorDetails = '';
      if (isAuthError) {
        errorDetails = i18next.t('status.authErrorDetails');
      } else {
        errorDetails = i18next.t('status.forbiddenErrorDetails');
      }

      // Si hay detalles en el error, usarlos
      if ('details' in error && typeof error.details === 'string') {
        errorDetails = error.details;
      }

      // Actualizar el estado global con el error
      next(
        setStatus({
          type: errorType,
          message: errorMessage,
          details: errorDetails,
        })
      );

      // Si es un error de autenticación, redirigir al login
      if (isAuthError) {
        // Limpiar token
        localStorage.removeItem('token');
      }
    }
  }

  return next(action);
};
